// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GrammarTipsModalComponent } from '../Components/videos/grammar-tips/grammar-tips-modal/grammar-tips-modal.component';
import { RouterModule } from '@angular/router';
import { ProductWalkthroughtModalComponent } from '../Components/product-walkthrought-modal/product-walkthrought-modal.component';
import { WebinarModalComponent } from '../Components/videos/webinar-modal/webinar-modal.component';

@NgModule({
  declarations: [
    GrammarTipsModalComponent,
    ProductWalkthroughtModalComponent,
    WebinarModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    GrammarTipsModalComponent,
    ProductWalkthroughtModalComponent,
    WebinarModalComponent
  ]
})

export class SharedModule { }
